module.exports = __webpack_public_path__ + "static/media/splash-logo.7dc7c2ab.png";